import { Base } from '@studiometa/js-toolkit';
import Post from './Post.js';

/**
 * Instagram
 */
export default class Instagram extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Instagram',
    components: {
      Post,
    },
    options: {
      url: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Mount component
   */
  mounted() {
    fetch(this.$options.url)
      .then((response) => response.json())
      .then((response) => {
        const results = response.data;
        results.forEach((element, index) => {
          if (this.$children.Post[index]) {
            this.$children.Post[index].setInstaData(
              element.link,
              element.images.standard_resolution.url,
            );
          }
        });
      })
      .catch((e) => {
        console.error(e);
      });
  }
}
